<script>
    import { blur } from "svelte/transition";
    import { getContext } from "svelte";
    import { display } from "../stores";
    import Close from "../Icons/Close.svelte";
    import Tick from "../Icons/Tick.svelte";
    
    const {notification} = getContext('notification');
    const notificationTypeZ = $notification.type==0;
    </script>
    
    <div>
        <div style={`height:${$notification.text.length<100?60:$notification.text.length*0.3}px`} class="note {$display === 'm_2' ? 'm2' : $display === 'm' ? 'm' : ''}" id="notification" transition:blur|local={{ y: -200, duration: 500 }}>
            {#if notificationTypeZ}
                <Close />
            {:else if $notification.type==1}
                <Tick />
            {/if}
            <div id="textWrapper">
                <p style={notificationTypeZ?`top:25%`:''} class={$display === 'm_2' ? 'm2' : $display === 'm' ? 'm' : ''} >
                    {$notification.text}
                </p>
            </div>
            
        </div>
    </div>
    
    <style>
    .note.m, .note.m2 {
        max-width: 80%;
        left: 10%;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
        align-content: space-evenly;
        max-height: 129px;
    }
    #notification {
        top: 4%;
        flex-direction: row;
        flex-wrap: wrap;
        position: fixed;
        display: flex;
        padding: 5px;
        max-width: 60%;
        max-height: 20%;
        justify-content: space-around;
        align-items: center;
        left: 20%;
        z-index: var(--z-index-notification);
        width: 90%;
        background: var(--color_scheme-background);
        box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
        border-top: 2px solid var(--color_scheme-contrast_color);
    }   
    p {
        position: relative;
        text-align: -webkit-center;
        overflow-y: scroll;
        white-space: normal;
    }
    p.m,
    p.m2 {
        white-space: normal;
    }
    #textWrapper{
        height: 90%;
        width: 80%;
        overflow-y: scroll;
        scroll-behavior: smooth;
    }
    ::-webkit-scrollbar {
        width: 0px;
        background: transparent;
    }
    </style>